import { Invoice } from "../../../corelogic/models/entities/billing-new/invoice";
import { billingNewGatewayInterface } from "../../../corelogic/usecases/billing-new/billingNewGatewayInterface";
import client from "../libs/client";

export default class APIBillingNewGateway implements billingNewGatewayInterface {
	error: any;

	setError = (error: boolean) => {
		this.error = error;
	};

	async getInvoices(participantIds: number[]): Promise<Invoice[] | null> {

		const { data: invoices } = await client.get(`/billing/invoices/by-consumers?participantsIds=${participantIds.join(',')}`);
		return invoices.map((invoice: any) => {
			return new Invoice(
				invoice.id,
				invoice.number,
				invoice.periodStart,
				invoice.periodEnd,
				invoice.amount,
				invoice.synthesisDocumentId,
				invoice.consumerId || invoice.billableEntity.consumerIds.find((id: number) => participantIds.includes(id)), // <-- participantId doit être ici
				invoice.isLegacyBill // <-- isLegacyBill doit être en dernier
			);
		});
	}

	async downloadInvoice(participantId: number, invoiceId: number, lang?: string, isLegacyBill?: boolean): Promise<void> {
		const { data: invoiceUrl } = await client.get(
			`/billing/invoices/${invoiceId}/download?language=${lang}&isLegacyBill=${isLegacyBill}`
		);
		window.open(invoiceUrl);
	}
}
